/**
 * Project name: Maal Project
 * Created Date: Wednesday, February 5th 2020, 1:55:20 am
 * Author: Marek Goc (goc_marek@ma-al.com)
 * -----
 * Copyright (c) 2020 Maal Sp. z o.o.
 * ------------------------------------
 */


import $ from 'jquery';
/* expose jQuery for modules */
window.$ = $;
window.jQuery = $;

// import 'jquery-migrate';
// import 'jquery.browser';
// import '@prestashop-core/jquery.live-polyfill';
import './cart';
import './checkout';
import './facets';
import './listing';
import './product';
import './address';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import {psShowHide} from './common';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  psShowHide();
});
